/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wsc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste messy text…`)
};

const es_wsc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega texto desordenado…`)
};

const de_wsc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unordentlichen Text einfügen…`)
};

const nl_wsc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak rommelige tekst…`)
};

const fr_wsc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez du texte mal formaté…`)
};

const it_wsc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla testo disordinato…`)
};

const pt_br2_wsc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole texto desorganizado…`)
};

const pt_wsc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole texto desorganizado…`)
};

const ja_wsc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`汚いテキストを貼り付け…`)
};

const zh_wsc_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴杂乱的文本…`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wsc_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wsc_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wsc_placeholder", locale)
	if (locale === "en") return en_wsc_placeholder(inputs)
	if (locale === "es") return es_wsc_placeholder(inputs)
	if (locale === "de") return de_wsc_placeholder(inputs)
	if (locale === "nl") return nl_wsc_placeholder(inputs)
	if (locale === "fr") return fr_wsc_placeholder(inputs)
	if (locale === "it") return it_wsc_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_wsc_placeholder(inputs)
	if (locale === "pt") return pt_wsc_placeholder(inputs)
	if (locale === "ja") return ja_wsc_placeholder(inputs)
	return zh_wsc_placeholder(inputs)
};